import { render } from "./UserAuth.vue?vue&type=template&id=3c2c6416&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=3c2c6416&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c2c6416"

export default script